import { useState } from "react";
import { SlotPicker } from "@/components/booking/SlotPicker";
import { BookingForm } from "@/components/booking/BookingForm";
import { BookingConfirmed } from "@/components/booking/BookingConfirmed";

const Step = ({ n, label, active }) => (
  <span className={`flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] ${active ? "text-gold" : "text-slate-600"}`}>
    <span className={`flex h-5 w-5 items-center justify-center border text-[9px] ${active ? "border-gold" : "border-slate-700"}`}>{n}</span>
    {label}
  </span>
);

export const BookingPanel = () => {
  const [date, setDate] = useState();
  const [slot, setSlot] = useState(null);
  const [confirmed, setConfirmed] = useState(null);

  if (confirmed) {
    return (
      <BookingConfirmed
        booking={confirmed}
        onReset={() => {
          setConfirmed(null);
          setDate(undefined);
          setSlot(null);
        }}
      />
    );
  }

  return (
    <div className="glass-panel p-6 sm:p-8" data-testid="booking-panel">
      <div className="flex flex-wrap gap-x-8 gap-y-3 border-b border-white/10 pb-6">
        <Step n="1" label="Date" active />
        <Step n="2" label="Time" active={!!date} />
        <Step n="3" label="Details" active={!!slot} />
      </div>

      <div className="mt-6">
        <SlotPicker date={date} onDateChange={setDate} slot={slot} onSelect={setSlot} />
      </div>

      {slot && (
        <div className="mt-8 border-t border-white/10 pt-8">
          <BookingForm slot={slot} date={date} onConfirmed={setConfirmed} />
        </div>
      )}
    </div>
  );
};
